/* eslint-disable  @typescript-eslint/no-explicit-any */
import React from "react";
import "./create-lead-address-details.scss";
import AddressFormFields from "../../../../../common/components/address-form-fields/address-form-fields";

const CreateLeadAddressDetails = (props: any) => {
  return (
    <div className="create-lead-address-details">
      <AddressFormFields postCode="zipcode" />
    </div>
  );
};

export default CreateLeadAddressDetails;
